export default __webpack_public_path__ + "static/media/acropolis-lab-rojo_logo.69545a6b.png";